import adminApiClient from '../../api/base/adminApiClient'

export interface PushAudienceResponse {
  data: {
    audience: number
  }
}

/** 휴대폰 알림 허용(OS 권한)과 광고성 푸시 동의를 나란히 센 값 */
export interface PushPermissionStats {
  total: number
  granted: number
  denied: number
  /** 아직 결과가 안 온 사람 (2026-11-01 이전 가입자 등) */
  unknown: number
  signup: { granted: number; answered: number }
  home: { granted: number; answered: number }
  ad_consent: number
  /** 광고에는 동의했지만 휴대폰 알림을 꺼서, 보내도 안 뜨는 사람 */
  ad_consent_but_denied: number
  /** 첫 결과가 들어온 시각 */
  since: string | null
}

export interface SendPushBroadcastRequest {
  title: string
  body: string
}

export interface SendPushBroadcastResponse {
  message: string
  data: {
    total: number
    sent: number
    failed: number
  }
}

export const adminPushApi = {
  getPushPermissionStats: async (): Promise<{ data: PushPermissionStats }> => {
    const response = await adminApiClient.get<{ data: PushPermissionStats }>(
      '/admin/push/permission-stats'
    )
    return response.data
  },

  getPushAudience: async (): Promise<PushAudienceResponse> => {
    const response = await adminApiClient.get<PushAudienceResponse>(
      '/admin/push/audience'
    )
    return response.data
  },

  sendPushBroadcast: async (
    data: SendPushBroadcastRequest
  ): Promise<SendPushBroadcastResponse> => {
    const response = await adminApiClient.post<SendPushBroadcastResponse>(
      '/admin/push/broadcast',
      data
    )
    return response.data
  },
}
